module.exports = __webpack_public_path__ + "img/qu_mx.9ca1c1b.jpg";